// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .section .bold[data-v-0244b40b]  .el-form-item__label {\n  font-weight: bold;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
